import React, { Component } from 'react';
import moment from 'moment';
import { refundPickupTickets } from '../schema/skidata-schema.graphql';
// @material-ui/core components
import Typography from '@material-ui/core/Typography';
// @material-ui/icons
// core components
import GridItem from 'components/Grid/GridItem.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardIcon from 'components/Card/CardIcon.jsx';
import SpeakerPhone from '@material-ui/icons/SpeakerPhone';
import Spinner from '../../../components/Spinner/Spinner';
import SkidataTicketTable from './SkidataTicketTable';
import CancelOrderButton from './CancelOrderButton';
import { withSnackbar } from '../../snackbar/SnackbarContext';
import { ReturnTicketTypes } from './ticketTypes.js';
import CommentSection from './CommentSection';

class QrCodeTicketsSection extends Component {
  isCancelable = ticket => {
    const isActive = ReturnTicketTypes.includes(ticket.ticketType)
      ? moment().isBetween(
          ticket.validFrom,
          moment(ticket.validTo).add(9, 'days'),
          'day',
          '[]'
        )
      : moment().isBetween(
          ticket.validFrom,
          moment(ticket.validTo).add(1, 'days'),
          'day',
          '[]'
        );

    return (
      ticket.pricingStrategy !== 'PRESALE' &&
      ticket.pricingStrategy !== 'PRESALE_FREE_KIDS_SATURDAY' &&
      ticket.permissionState !== 'CONSUMED' &&
      !isActive &&
      (ticket.salesState === 'RESERVED' ||
        ticket.salesState === 'BOOKED_AND_TRANSFERRED' ||
        ticket.salesState === 'BOOKED_AND_REJECTED' ||
        ticket.salesState === 'BOOKED')
    );
  };

  render() {
    const { order, onCancelTickets, canceling, role, onRequestAddComment, sendingComment } = this.props;
    const tickets = order.tickets.filter(ticket => ticket.barcode != null);

    const refundableTicketIds = tickets
      .filter(this.isCancelable)
      .map(ticket => ticket.id);
    const cancelable = refundableTicketIds.length !== 0;

    return tickets.length ? (
      <GridItem xs={12} sm={12} md={12} lg={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="info">
              <SpeakerPhone />
            </CardIcon>
          </CardHeader>
          <CardBody>
            <Typography variant="headline" color="textSecondary">
              Qr-Code Tickets
            </Typography>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'flex-end',
              }}
            >
              <CommentSection
                onRequestAddComment={onRequestAddComment}
                role={role}
                loading={sendingComment}
              />
              {cancelable ? (
                <CancelOrderButton
                  buttonText="Alle Qr-Code Tickets Stornieren"
                  loading={canceling}
                  isOnlyVoucher={
                    (!order.payment ||
                      (order.payment &&
                        order.payment.cardType === 'VOUCHER')) &&
                    order.voucher
                  }
                  onCancelOrder={(sendConfirmationMail, refundVoucher) =>
                    onCancelTickets(
                      refundableTicketIds,
                      sendConfirmationMail,
                      refundVoucher
                    )
                  }
                  role={role}
                />
              ) : null}
            </div>
            {order ? (
              <SkidataTicketTable
                tickets={tickets}
                orderId={order.id}
                onCancelTickets={onCancelTickets}
                cancelable={refundableTicketIds.length > 0}
                canceling={canceling}
                role={role}
                isOnlyVoucher={
                  (!order.payment ||
                    (order.payment && order.payment.cardType === 'VOUCHER')) &&
                  order.voucher
                }
              />
            ) : (
              <Spinner loading />
            )}
          </CardBody>
        </Card>
      </GridItem>
    ) : null;
  }
}

export default withSnackbar(QrCodeTicketsSection);



// WEBPACK FOOTER //
// ./src/views/skidata/components/QrCodeTicketsSection.jsx